import { memo } from 'react'
import {Routes,Route} from 'react-router-dom';
import {default as RegisterCandidate} from './RegisterCandidate'
import {default as ViewStudentResult} from './ViewStudentResult'
import UpdateStartLevel from './UpdateStartLevel';


const Candidates = () => {
  return (
    <Routes>
      <Route path="/" element={<RegisterCandidate />}/>
      <Route path="/register-candidate" element={<RegisterCandidate/>}/>
      <Route path="/update-start-level" element={<UpdateStartLevel/>}/>
      <Route path="/view-student-result" element={<ViewStudentResult/>}/>

    </Routes>
  )
}

export default memo(Candidates) 


const DefaultCandidate = ()=>{
  return <div>Candidate</div>
}